<template>
  <transition name="el-loading-fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      class="el-loading-mask"
      :style="{ backgroundColor: background || '' }"
      :class="[customClass, { 'is-fullscreen': fullscreen }]">
      <div class="el-loading-spinner">
        <svg v-if="!spinner" class="circular" viewBox="0 0 60 60">
          <circle class="path-bg" cx="30" cy="30" r="28" stroke-width="4" fill="none"/>
          <circle class="path" cx="30" cy="30" r="28" fill="none"/>
        </svg>
        <i v-else :class="spinner"></i>
        <p v-if="text" class="el-loading-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: ''
    };
  },

  methods: {
    handleAfterLeave() {
      this.$emit('after-leave');
    },
    setText(text) {
      this.text = text;
    }
  }
};
</script>
<style scoped lang="scss">
.el-loading-spinner .circular {
    width: 60px;
    height: 60px;
}

.el-loading-spinner .path {
    stroke: #274ea4;
    stroke-width: 4;
}

.el-loading-spinner .path-bg {
    stroke: #eff2f8;
    //stroke-width: 4;
}

.el-loading-spinner .el-loading-text {
    margin-top: 10px;
    color: #274ea4;
    font-size: 14px;
    line-height: 18px;
}
//.el-loading-spinner .path,
//.el-loading-spinner .circular {
//  animation: none;
//}
</style>
